import { requests } from "../../../../api/agent"

export default {
	create: (params) => requests.post('/ReMeasurementUnitAO/create', params),
	update: (params) => requests.post('/ReMeasurementUnitAO/update', params),
	delete: (params) => requests.getWithParams('/ReMeasurementUnitAO/delete', params),
	restore: (params) => requests.getWithParams('/ReMeasurementUnitAO/restore', params),
	getPaged: (params) => requests.getWithParams('/ReMeasurementUnitAO/getPaged', params),
	getPagedAudit: (params) => requests.getWithParams('/ReMeasurementUnitAO/getPagedAudit', params),
	getPagedAll: (params) => requests.getWithParams('/ReMeasurementUnitAO/getPagedAll', params),
	getList: (params) => requests.getWithParams('/ReMeasurementUnitAO/getList', params)
}